import { LogIn } from "lucide-react"
import Footer from "../components/Footer/FooterSection"
import HeaderTwo from "../components/HeaderTwo/HeaderTwoSection"
import "../styles/authrequired.scss"
import { NavLink } from "react-router-dom"
import 'animate.css'

const AuthRequired = () => {

   

    return (<>
        <HeaderTwo></HeaderTwo>

        {/* <CustomHistory></CustomHistory> */}

        <div className="content authrequired animate__animated animate__fadeIn animate__fast">


            <div className="centerdiv">


                <div className='icon_enter'> 
                    <div className="circ">
                        <LogIn size={28} color="#0339f8"></LogIn>
                    </div>
                    
                    </div>


                <div className="title">
                    Sign In to Continue
                </div>

                <div className="text">
                    Please sign in to your account or create a new one to continue.
                </div>


                <div className="button-group">
                    <NavLink to={'/signin'}><div className="btn sign-in">Sign In Or Sign Up</div></NavLink> 
                    <NavLink to={'/home'}><div className='crt_acc'>Go Home</div></NavLink>
                </div>

            </div>


        </div>

        <Footer></Footer>


    </>

    )
}

export default AuthRequired;